import { render, staticRenderFns } from "./NavigationDrawerStudents.vue?vue&type=template&id=0710c375&scoped=true"
import script from "./NavigationDrawerStudents.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerStudents.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerStudents.vue?vue&type=style&index=0&id=0710c375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710c375",
  null
  
)

export default component.exports